import type { TourTicketSalesQuery } from '@gql/types/graphql';
import type { TicketSalesTour, TicketShow } from '@app-types/ticketSales';

function displayText(value: string | null | undefined): string {
  return value?.trim() || '-';
}

function firstEventDate(shows: TicketShow[]): string | null {
  return (
    shows
      .map((show) => show.eventDate)
      .filter((date): date is string => Boolean(date))
      .sort()[0] ?? null
  );
}

export function mapTourTicketSalesToStore(response: TourTicketSalesQuery['tourTicketSales']): TicketSalesTour {
  const venues = response.venues.map((venue) => {
    const shows = venue.shows.map((show, index) => ({
      id: show.showId,
      showNumber: index + 1,
      eventDate: show.showDate ?? null,
      allocations: show.allocations.map((allocation) => ({
        id: allocation.allocationId,
        ticketCompany: displayText(allocation.ticketCompanyName),
        ticketType: displayText(allocation.ticketType),
        ticketName: displayText(allocation.ticketName),
        allocation: allocation.allocation ?? null,
        price: allocation.price ?? null,
        lastUpdated: allocation.lastUpdate ?? null,
        feedSales: null,
        manualSales: allocation.manualSales ?? null,
        totalSales: null,
        percentSold: null,
        unsold: null,
        canModifyAdjustments: allocation.canModifyAdjustments,
      })),
    }));

    return {
      id: venue.venueId,
      name: displayText(venue.venueName),
      showCount: shows.length,
      firstEventDate: firstEventDate(shows),
      shows,
    };
  });

  return {
    id: response.tour.id,
    name: displayText(response.tour.name),
    headliner: displayText(response.tour.headliner),
    coHeadliners: response.tour.coHeadliners.filter((headliner) => headliner.trim()).join(', ') || '-',
    company: displayText(response.tour.company),
    multiLegTour: response.tour.isMultiLegTour ? 'Yes' : 'No',
    buyer: displayText(response.tour.buyer),
    operator: displayText(response.tour.operator),
    venues,
  };
}
